import { useQuery } from '@tanstack/react-query';
import { DEFAULT_QUERY_OPTIONS } from '@projects/queries/constants';
import ScimToken from '../models/ScimToken';
import useScimSystem from '../systems/useScimSystem';
import { QueryKeys } from './keysAndFilters';

const useScimTokenQuery = ( { workspaceID }: { workspaceID: number } ) => {
	const system = useScimSystem();

	return useQuery(
		QueryKeys.forScimToken( { workspaceID } ),
		() => system.fetchScimToken( { workspaceID } ),
		{
			...DEFAULT_QUERY_OPTIONS,
			select: ScimToken.fromJSON
		}
	);
};

export default useScimTokenQuery;
